import { COMPANY } from '@shared/config';

export interface SeoPage {
  path: string;
  title: string;
  description: string;
  image?: string;
  noindex?: boolean;
  schema?: object[];
}

export const absoluteUrl = (path: string) => new URL(path, `${COMPANY.site}/`).href;

export const getSocialImage = (page: SeoPage) => ({
  url: absoluteUrl(page.image ?? '/og-image.png'),
  type: page.image?.endsWith('.webp') ? 'image/webp' : 'image/png',
  width: page.image ? undefined : '1200',
  height: page.image ? undefined : '630',
});

export const NOT_FOUND: SeoPage = {
  path: '/404',
  title: 'Страница не найдена — РПСО',
  description: 'Страница не найдена. Выберите оборудование в каталоге РПСО.',
  noindex: true,
};
export const schemaJson = (page: SeoPage) =>
  JSON.stringify({ '@context': 'https://schema.org', '@graph': page.schema ?? [] }).replace(
    /</g,
    '\\u003c',
  );
